import actionTypes from "../actions/actionTypes";

const initialState = {
  eventMyDrafts: null,
  eventMyDraftsCount: null,
  eventPublishedByMe: null,
  eventPublishedByMeCount: null,
  eventPublishedByOthers: null,
  eventPublishedByOthersCount: null,
  eventAddQuizImage: [],
};

const eventReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.eventTypes.EVENT_GET_MY_DRAFTS:
      return {
        ...state,
        eventMyDrafts: payload,
        eventMyDraftsCount: action.count,
      };
    case actionTypes.eventTypes.EVENT_PUBLISHED_BY_ME:
      return {
        ...state,
        eventPublishedByMe: payload,
        eventPublishedByMeCount: action.count,
      };
    case actionTypes.eventTypes.EVENT_PUBLISHED_BY_OTHERS:
      return {
        ...state,
        eventPublishedByOthers: payload,
        eventPublishedByOthersCount: action.count,
      };
    case actionTypes.eventTypes.EVENT_ADD_QUIZ_IMAGE:
      return {
        ...state,
        eventAddQuizImage: payload,
      };
    default:
      return state;
  }
};

export default eventReducer;
